import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transmissions",
  "use": "transmissions-usage",
  "viewBox": "0 0 15.55 7.2",
  "content": "<symbol viewBox=\"0 0 15.55 7.2\" id=\"transmissions\"><title>TransmissionsAsset 1</title>\r\n<polygon points=\"1 7.2 0 7.2 0 0 1 0 1 3.35 13.65 3.35 11.18 0.88 11.89 0.17 15.55 3.85 12.31 7.16 11.59 6.46 13.66 4.35 1 4.35 1 7.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol